import { List, Record } from 'immutable'
import { IIndividualAmount, IndividualAmount } from './IndividualAmount'

export interface IBrokeragePipelineCommissionFee {
  readonly bonuses: List<IIndividualAmount>
  readonly companySplit: number
  readonly individualSplits: List<IIndividualAmount>
  readonly totalFeePercent: number
}

const BrokeragePipelineCommissionFeeRecord = Record({
  bonuses: List<IndividualAmount>(),
  companySplit: 0,
  individualSplits: List<IndividualAmount>(),
  totalFeePercent: 0,
})

export class BrokeragePipelineCommissionFee
  extends BrokeragePipelineCommissionFeeRecord
  implements IBrokeragePipelineCommissionFee {
  public static fromJS(
    initialState?: Partial<IBrokeragePipelineCommissionFee>,
  ) {
    if (!initialState) {
      return new BrokeragePipelineCommissionFee()
    }

    const { bonuses, individualSplits, ...rest } = initialState

    return new BrokeragePipelineCommissionFee({
      bonuses: Array.isArray(bonuses)
        ? List(bonuses.map((b) => IndividualAmount.fromJS(b)))
        : List<IndividualAmount>(),
      individualSplits: Array.isArray(individualSplits)
        ? List(individualSplits.map((i) => IndividualAmount.fromJS(i)))
        : List<IndividualAmount>(),
      ...rest,
    })
  }

  public readonly bonuses: List<IndividualAmount>
  public readonly companySplit: number
  public readonly individualSplits: List<IndividualAmount>
  public readonly totalFeePercent: number

  constructor(props?: Partial<BrokeragePipelineCommissionFee>) {
    props ? super(props) : super()
  }
}
